<template>
  <v-data-table
    v-if="_currentDocument.name"
    :headers="documentTypes[_currentDocument.name].headers"
    :items="_records"
    item-key="nomenklatura_id"
    hide-actions
  >
    <template v-slot:items="props">
      <tr>
        <td class="justify-center layout px-0">
          <v-icon
            small
            @click="openOptionsDialog(props.item)"
          >
            mdi-settings
          </v-icon>
        </td>
        <td class="text-xs-right">{{ props.item.nomenklatura_id }}</td>
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right" style="text-align: right">
          <input
            v-model.number="props.item.kolichestvo"
            @focus="$event.target.select()"
            @change="_refreshItemsTableQuantity"
            type="number"
            min="1"
            v-numericOnly
            pattern="\d*"
            class="table-qty">
        </td>
        <td class="text-xs-right">{{ props.item.rezerv }}</td>
        <td class="text-xs-right" v-html="props.item.tsena + (!parseInt(props.item.has_nds_rate) && _currentDocument.name === 'schet' ? '<br><span class=\'grey--text caption\'>без НДС</span>' : '')"></td>
        <td class="text-xs-right">{{ (props.item.tsena * props.item.rezerv) | numberFormat(2, '.', ' ') }}
        <td class="text-xs-right">{{ (props.item.tsena * props.item.kolichestvo) | numberFormat(2, '.', ' ') }}
        </td>
        <td class="text-xs-left">
          <v-tooltip bottom>
            <v-icon
              slot="activator"
              color="red"
              @click="deleteRow(props.item)"
            >
              mdi-delete
            </v-icon>
            <span>Удалить</span>
          </v-tooltip>
        </td>
      </tr>
    </template>
    <template slot="no-data">
      <empty-table
        :emptyText="'В документе нет товаров'"
      />
    </template>
    <template slot="footer">
      <td colspan="6">
      </td>
      <td class="text-xs-right"><strong>{{ documentSummaCurrent | numberFormat(2, '.', ' ') }}</strong></td>
      <td class="text-xs-right"><strong>{{ documentSummaApproximate | numberFormat(2, '.', ' ') }}</strong></td>
      <td></td>
    </template>
  </v-data-table>
</template>

<script>
import emptyTable from '@/components/helpers/EmptyTable'
import { mapGetters, mapActions } from 'vuex'
import { mapMultiRowFields } from 'vuex-map-fields'
import { numericOnly } from '@/directives/numericOnly'
import numberFormat from '@/filters/numberFormat'

export default {
  name: 'CatalogDocumentTable',
  directives: {
    numericOnly
  },
  filters: {
    numberFormat
  },
  props: {
    documentTypes: {
      default: () => {},
      required: true,
      type: Object
    }
  },
  components: {
    emptyTable
  },
  computed: {
    ...mapGetters('catalog', {
      _currentDocument: 'currentDocument'
    }),
    ...mapMultiRowFields('catalog', {
      _records: 'currentDocument.records'
    }),
    documentSummaCurrent () {
      let summa = 0
      if (this._currentDocument.records) {
        this._currentDocument.records.forEach(function (v) {
          summa += parseFloat(v.tsena) * parseInt(v.rezerv)
        })
      }
      return summa
    },
    documentSummaApproximate () {
      let summa = 0
      if (this._currentDocument.records) {
        this._currentDocument.records.forEach(function (v) {
          summa += parseFloat(v.tsena) * parseInt(v.kolichestvo)
        })
      }

      return summa
    }
  },
  methods: {
    ...mapActions('catalog', {
      _deleteRow: 'deleteRow',
      _refreshItemsTableQuantity: 'refreshItemsTableQuantity'
    }),
    deleteRow (item) {
      this._deleteRow(item)
      this._refreshItemsTableQuantity()
    },
    openOptionsDialog (item) {
      this.$emit('openOptionsDialog', { ...this._currentDocument.records[this._records.indexOf(item)] })
    }
  }
}
</script>

<style scoped>

</style>
